export enum ContactCount {
  InProgress = 'in-progress',
  AllStarted = 'all-started',
  ExitRules = 'exit-rules',
  AllCompleted = 'all-completed',
}
